<script setup lang="ts">
import { UiDialog, UiInputField, UiStandardButton, UiTextarea, UiText } from '@shopexperts/shared';

const props = defineProps<{
  name: string;
  label: string;
  description: string;
  canCreate: boolean;
  isCreating: boolean;
}>();

const open = defineModel<boolean>({ required: true });

const emit = defineEmits<{
  updateName: [value: string];
  updateLabel: [value: string];
  updateDescription: [value: string];
  submit: [];
}>();
</script>

<template>
  <UiDialog
    v-model="open"
    :loading="props.isCreating"
    title="Create schema"
    text="Create a schema with a starter title field, then add metafields with the GUI field picker."
    :hide-close-button="props.isCreating"
  >
    <div class="flex flex-col gap-4">
      <div class="flex flex-col gap-1">
        <UiText as="label" variant="label" text="Display label" />
        <UiInputField
          :model-value="props.label"
          placeholder="Partner pages"
          @update:model-value="emit('updateLabel', String($event))"
        />
      </div>
      <div class="flex flex-col gap-1">
        <UiText as="label" variant="label" text="Schema handle" />
        <UiInputField
          :model-value="props.name"
          placeholder="partner-pages"
          @update:model-value="emit('updateName', String($event))"
        />
      </div>
      <div class="flex flex-col gap-1">
        <UiText as="label" variant="label" text="Description" />
        <UiTextarea
          :model-value="props.description"
          placeholder="Describe what this schema controls"
          :rows="3"
          @update:model-value="emit('updateDescription', String($event))"
        />
      </div>
    </div>

    <template #footer>
      <div class="flex flex-col gap-3">
        <UiStandardButton
          label="Create schema"
          icon="plus"
          :disabled="!props.canCreate || props.isCreating"
          @click="emit('submit')"
        />
        <UiStandardButton
          label="Cancel"
          variant="outline"
          :disabled="props.isCreating"
          @click="open = false"
        />
      </div>
    </template>
  </UiDialog>
</template>
